// Lazy-loads pdf.js for AiChatPanel, so the ~1 MB library is only fetched when
// someone opens a catalog with the AI panel (staging), never for ordinary use.
let loading = null;

export function loadPdfjs() {
  if (!loading) {
    loading = import(/* webpackChunkName: "pdfjs" */ "pdfjs-dist/legacy/build/pdf.mjs").then((pdfjs) => {
      // webpack emits the worker as its own file from this URL.
      pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
        import.meta.url
      ).toString();
      return pdfjs;
    });
  }
  return loading;
}
